import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {Highlight} from "@app/pipes/highlighter/highlight.pipe";

@NgModule({
  declarations: [Highlight],
  imports: [CommonModule],
  exports: [Highlight],
})
export class HighlightModule {}
